<template>
  <div class="home">
        <!-- main-area -->
        <main class="fix">
            <!-- slider-area -->
            <section class="slider__area">
                <div id="carouselExampleFade" class="carousel slide carousel-fade" data-bs-ride="carousel">
                    <div class="carousel-indicators">
                        <button
                            v-for="(banner, index) in list_banner"
                            :key="banner.id"
                            type="button"
                            data-bs-target="#carouselExampleFade"
                            :data-bs-slide-to="index"
                            :class="{ active: index === 0 }"
                            :aria-current="index === 0 ? 'true' : null"
                            :aria-label="`Slide ${index + 1}`" >
                        </button>
                    </div>
                    <div class="carousel-inner">
                        <div v-for="(banner, index) in list_banner" :key="banner.id" :class="['carousel-item', { active: index === 0 }]">
                        <img :src="file_path+banner.file" class="d-block w-100" alt="...">
                        </div>
                    </div>
                    <button class="link-arrow carousel-control-prev" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="prev">
                        <a href="javascript:void(0)">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 15" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z" fill="currentColor"stroke="currentColor" stroke-width="1.25"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z" fill="currentColor"stroke="currentColor" stroke-width="1.25"/>
                            </svg>
                        </a>
                    </button>
                    <button class="link-arrow carousel-control-next" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="next">
                        <a href="javascript:void(0)">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none" width="24" height="24">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 1 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z" fill="currentColor" stroke="currentColor" stroke-width="1.25"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.646 1.746a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 1 1-.708-.708L10.293 8 4.646 2.454a.5.5 0 0 1 0-.708z" fill="currentColor" stroke="currentColor" stroke-width="1.25"/>
                            </svg>
                        </a>
                    </button>
                </div>
            </section>
            <!-- slider-area-end -->
             <!-- services-area -->
            <section class="services__area-home-12 pt-120 pb-120">
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-lg-6">
                            <div class="position-relative text-center">
                                <img class="position-relative z-1" :src="file_path+sambutan_foto" style="width: 70%;" alt="DPUPR" />
                                <img class="position-absolute bottom-0 start-50 translate-middle-x z-0" src="assets/img/home-12/shape-2.png" alt="" />
                                <img class="position-absolute bottom-50 shape-3 p-4" src="assets/img/home-12/shape-3.png" alt="" />
                                <img class="position-absolute shape-4" src="assets/img/home-12/shape-4.png" alt="" />
                                <img class="position-absolute top-0 end-0 pe-5 pt-5 alltuchtopdown" src="assets/img/home-12/shape-5.png" alt="" />
                            </div>
                            <div class="position-relative text-center mt-1">
                                <h4 class="title">{{ sambutan_nama }}</h4>
                            </div>  
                        </div>
                        <div class="col-lg-5 offset-lg-1 mt-lg-0 mt-5">
                            <div class="section-title mb-30 tg-heading-subheading animation-style3">
                                <span class="sub-title" style="font-size: larger;">SAMBUTAN KEPALA DINAS PEKERJAAN UMUM & PENATAAN RUANG</span>
                            </div>
                            <div class="services__list-home-12 d-flex gap-4 mb-3">
                                <div class="content">
                                    <p v-html="sambutan_isi"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- services-area-end -->
             <!-- services-area -->
            <section class="services__area-five services__bg-five home-9">
                <div class="shape-1 alltuchtopdown d-none d-md-block">
                    <img src="assets/img/images/h9_shape01.png" alt="DPUPR" />
                </div>
                <div class="shape-2 d-none d-md-block">
                    <img src="assets/img/images/h9_shape02.png" alt="DPUPR" />
                </div>
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-xl-6 col-lg-8">
                            <div class="section-title text-center mb-40">
                                <!-- <span class="sub-title">WHAT WE OFFER</span> -->
                                <h2 class="title text-white">Informasi Terbaru</h2>
                            </div>
                        </div>
                    </div>
                    <div class="services-item-wrap">
                        <div class="row justify-content-center">
                            <div class="col-lg-4 col-md-6 col-sm-8" v-for="berita in list_berita" :key="berita.id">
                                <div class="services-item shine-animate-item">
                                    <div class="services-thumb">
                                        <a @click.prevent="push_berita(berita.id)" href="javascript:void(0);" class="shine-animate"><img :src="file_path+berita.foto" alt="DPUPR" /></a>
                                    </div>
                                    <div class="services-content">
                                        <div class="icon">
                                            <i class="fas fa-calendar-alt"></i> {{convert_tgl(berita.createAt)}}
                                        </div>
                                        <h6><a @click.prevent="push_berita(berita.id)" href="javascript:void(0);">{{ berita.judul }}</a></h6>
                                        <p v-html="getFirstFiveWords(berita.isi)"></p>
                                        <a @click.prevent="push_berita(berita.id)" class="btn">Selengkapnya</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- services-area-end -->
            <!-- project-area -->
            <section class="project__area-two">
                <div class="container">
                    <div class="row">
                        <div class="col-xl-5 col-lg-6">
                            <div class="section-title mb-50 tg-heading-subheading animation-style3">
                                <span class="sub-title">Galeri</span>
                                <h4 class="title tg-element-title">Foto</h4>
                            </div>
                        </div>
                    </div>
                    <div class="row gutter-24">
                        <div v-for="(foto, index) in list_foto.slice(0, 5)" :key="foto.id" :class="['col-md-6', index === 4 ? 'col-lg-8' : 'col-lg-4']">
                            <div class="project__item-two">
                                <div class="project__thumb-two">
                                    <img :src="file_path+foto.foto" alt="DPUPR" />
                                </div>
                                <div class="project__content-two">
                                    <h2 class="title"><a @click.prevent="selectDataFoto(foto)" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#modalFoto">{{ getFirstWords(foto.judul) }}</a></h2>
                                    <div class="link-arrow link-arrow-two">
                                        <a @click.prevent="selectDataFoto(foto)" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#modalFoto">
                                            <i class="fas fa-info"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="project__shape-wrap-two">
                    <img class="dark-opacity" src="assets/img/project/h2_project_shape.png" alt="DPUPR" data-aos="fade-left" data-aos-delay="400" />
                </div>
                <div class="row justify-content-center">
                    <div class="col-12">
                        <div class="project-content-bottom">
                            <router-link to="/foto" class="btn">Lihat Semua Foto</router-link>
                        </div>
                    </div>
                </div>
            </section>
            <!-- project-area-end -->
            <!-- project-area -->
            <section class="project-area">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-xl-6 col-lg-7">
                            <div class="section-title text-center mb-50 tg-heading-subheading animation-style3">
                                <span class="sub-title">Galeri</span>
                                <h2 class="title tg-element-title">Video</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="project-item-wrap">
                    <div class="container custom-container-two">
                        <div class="row">
                            <div class="col-xl-4 col-md-6" v-for="video in list_video" :key="video.id">
                                <div class="project-item">
                                    <video width="100%" height="275px" controls class="rounded-video">
                                        <source :src="file_path+video.video" type="video/mp4">
                                    </video>
                                    <div class="project-content">
                                        <div class="left-side-content">
                                            <h4 class="title">{{ video.judul }}</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row justify-content-center">
                            <div class="col-12">
                                <div class="project-content-bottom">
                                    <router-link to="/video" class="btn">Lihat Semua Video</router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="project-shape-wrap">
                    <img class="dark-opacity" src="assets/img/project/project_shape01.png" alt="DPUPR" />
                    <img src="assets/img/project/project_shape02.png" alt="DPUPR" class="rotateme" />
                </div>
            </section>
            <!-- project-area-end -->
            <!-- counter-area -->
            <section class="counter-area">
                <div class="container">
                    <div class="row justify-content-center">
                        <div v-for="link in list_link" :key="link.id" class="col-xl-3 col-lg-4 col-sm-6">
                            <a class="counter-item" :href="link.url" target="_blank">
                                <div class="icon">
                                    <img class="image" :src="file_path+link.file" alt="">
                                </div>
                                <div class="content">
                                    <p>
                                        {{ link.deskripsi }}
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="counter-shape-wrap">
                    <img class="dark-opacity" src="assets/img/images/counter_shape01.png" alt="DPUPR" data-aos="fade-right" data-aos-delay="400" />
                    <img src="assets/img/images/counter_shape02.png" alt="DPUPR" data-parallax='{"x" : 100 , "y" : -100 }' />
                    <img class="dark-opacity" src="assets/img/images/counter_shape03.png" alt="DPUPR" data-aos="fade-left" data-aos-delay="400" />
                </div>
            </section>
            <!-- counter-area-end -->
        </main>
        <!-- main-area-end -->
        <div id="modalFoto" class="modal fade" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                <div class="modal-header">
                    <h6 class="modal-title">{{ foto.judul }}</h6>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <img style="border-radius: 10px;" :src="file_path+foto.foto" alt="DPUPR" />
                </div>
                <div class="modal-footer">
                </div>
                </div>
            </div>
        </div>
  </div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/css';

export default {
  name: 'HomeView',

  data () {
    return {
        file_path: this.$store.state.url.URL_APP + "uploads/",
        unit_kerja: this.$store.state.UNIT_KERJA,
        list_banner : [],
        interval: null,
        sambutan_nama: "",
        sambutan_foto: "",
        sambutan_isi: "",
        list_berita : [],
        list_foto : [],
        list_video : [],
        list_link : [],
        foto : {
            id : '',
            judul : '',
            deskripsi : '',
            foto : '',
            unit_kerja : '',
            createBy : '',
            createAt : '',
        }
    }
  },

  methods: {
    getBanner : function(){
      fetch(this.$store.state.url.URL_SLIDER, {
          method: "GET",
          headers: {
          "content-type": "application/json"
          }
      })
        .then(res => res.json())
        .then(res_data => {
            this.list_banner = res_data;
            console.log(this.list_banner);
      })
      .catch(error => {
        console.error('Error fetching banners:', error);
      });
    },

    getSambutan: function() {
        fetch(this.$store.state.url.URL_SAMBUTAN + "view", {
            method: "GET",
            headers: {
                "content-type": "application/json",
            },
        })
        .then(res => res.json())
        .then(res_data => {
            var sambutan = res_data[0];
            this.sambutan_nama = sambutan.judul;
            this.sambutan_foto = sambutan.foto;
            this.sambutan_isi = sambutan.isi; 
        });
    },
    getBerita: function() {
        this.cek_load_data_list = true;
        fetch(this.$store.state.url.URL_BERITA + "homeOPD", {
            method: "POST",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            },
                body: JSON.stringify({
                unit_kerja: this.unit_kerja,
                
            })
        })
            .then(res => res.json())
            .then(res_data => {
                this.list_berita = res_data;
        });
    },
    push_berita : function(id){
        this.$router.push('/detail_berita?id='+id);
    },
    convert_tgl: function(dateString) {
        var date = new Date(dateString);
        var getBulan = date.getMonth() + 1; var bulan = '';
        if (getBulan == '1') {bulan = 'Jan'} 
        else if(getBulan == '2') {bulan = 'Feb'}
        else if(getBulan == '3') {bulan = 'Mar'}
        else if(getBulan == '4') {bulan = 'Apr'}
        else if(getBulan == '5') {bulan = 'Mei'}
        else if(getBulan == '6') {bulan = 'Jun'}
        else if(getBulan == '7') {bulan = 'Jul'}
        else if(getBulan == '8') {bulan = 'Agt'}
        else if(getBulan == '9') {bulan = 'Sep'}
        else if(getBulan == '10') {bulan = 'Okt'}
        else if(getBulan == '11') {bulan = 'Nov'}
        else if(getBulan == '12') {bulan = 'Des'}

        return date.getDate() + " " + bulan + " " + date.getFullYear();
    },
    getFirstFiveWords(html) {
        const temp = document.createElement('div');
        temp.innerHTML = html;
        const text = temp.textContent || temp.innerText || '';
        const words = text.trim().split(/\s+/);
        const firstFive = words.slice(0, 12).join(' ');
        return firstFive + (words.length > 12 ? '...' : '');
    },
    getFirstWords(html) {
        const temp = document.createElement('div');
        temp.innerHTML = html;
        const text = temp.textContent || temp.innerText || '';
        const words = text.trim().split(/\s+/);
        const firstFive = words.slice(0, 6).join(' ');
        return firstFive + (words.length > 6 ? '...' : '');
    },
    getFoto: function() {
        fetch(this.$store.state.url.URL_FOTO, {
            method: "GET",
            headers: {
                "content-type": "application/json",
            },
        })
            .then(res => res.json())
            .then(res_data => { 
                this.list_foto = res_data
                console.log(res_data);
                
        });
    },
    selectDataFoto: function(foto) {
        this.foto = {
            id : foto.id,
            judul : foto.judul,
            deskripsi : foto.deskripsi,
            foto : foto.foto,
            unit_kerja : foto.unit_kerja,
            createBy : foto.createBy,
            createAt : foto.createAt,
        };
    },
    getVideo: function() {
        fetch(this.$store.state.url.URL_VIDEO, {
            method: "get",
            headers: {
                "content-type": "application/json",
            },
        })
            .then(res => res.json())
            .then(res_data => { 
                this.list_video = res_data
                console.log(res_data);
                
        });
    },
    getLink: function() {
        fetch(this.$store.state.url.URL_LINK, {
            method: "POST",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            },
                body: JSON.stringify({
                unit_kerja: this.unit_kerja,
                
            })
        })
            .then(res => res.json())
            .then(res_data => {
                this.list_link = res_data;
                console.log(res_data);
        });
    },
  },

  mounted () {
    this.getBanner();
    this.getSambutan();
    this.getBerita();
    this.getFoto();
    this.getVideo();
    this.getLink();
  },
  beforeDestroy() {
    if (this.mySwiper) {
      this.mySwiper.destroy();
    }
  }
}
</script>
